<template>
  <div class="slideDetailContainter">
    <div class="customer-prev slideButton cursorPointer">
      <div class="leftSingle single ursorPointer">
        <div class="flag"></div>
      </div>
    </div>
    <swiper
      :options="swiperOption"
      class="swiperCustomer cursorPointer"
      v-if="detail.contractSignList.length&&showFlow"
    >
      <swiper-slide
        class="swiperSlidecustomer"
        v-for="(item,index) in detail.contractSignList"
        :key="index"
      >
        <slide-item
          :detailItem="item"
          :detail="detail"
          :isLastMeFlag="meLastIndex.indexOf(index) > -1"
          :stopLastIndex="stopLastIndex===index"
          :returnLastIndex="returnLastIndex===index"
          :activeIndex="activeIndex===index"
          :lastIndex="index === (detail.contractSignList.length-1)"
          :info="detail.info"
          @rejectSignShow="rejectSignShow"
          @restDetail="restDetail"
        ></slide-item>
      </swiper-slide>
    </swiper>
    <div class="customer-next slideButton">
      <div class="rightSingle single cursorPointer">
        <span class="flag"></span>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import BaseApi from "@lib/baseApi.js";
import SlideItem from "./SlideItem.vue";
import "swiper/dist/css/swiper.css";
export default {
  props: ["detail"],
  data() {
    console.log();
    return {
      // 最后一个关于我的节点
      meLastIndex: [],
      // 最后一个终止的节点
      stopLastIndex: "",
      // 最后一个撤回的节点
      returnLastIndex: "",
      // 当前存在的节点
      activeIndex: "",
      // 是否显示
      showFlow: false,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesPerGroup: 1,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".customer-next",
          prevEl: ".customer-prev"
        }
      }
    };
  },
  components: {
    swiper,
    swiperSlide,
    SlideItem
  },
  created() {
    this.getCommonStatus();
    this.showFlow = true;
  },
  mounted() {},
  methods: {
    // deleteContract(item) {
    //   this.$emit("deleteContract", item);
    // },
    rejectSignShow(taskId) {
      this.$emit("rejectSignShow", taskId);
    },
    restDetail() {
      this.$emit("restDetail");
    },
    // judgeIsLastMeFlag(index) {
    //   console.log(this.meLastIndex.indexOf(index) > -1);
    //   return this.meLastIndex.indexOf(index) > -1;
    // },
    getCommonStatus() {
      let signIdArr = this.getUserId();
      let existArray = [];
      for (let i = this.detail.contractSignList.length - 1; i > -1; i--) {
        if (
          signIdArr.indexOf(
            this.detail.contractSignList[i].signUser.userId + ""
          ) > -1
        ) {
          if (
            existArray.indexOf(
              this.detail.contractSignList[i].signUser.userId
            ) == -1
          ) {
            this.meLastIndex.push(i);
            existArray.push(this.detail.contractSignList[i].signUser.userId);
          }
        }
        if (this.detail.contractSignList[i].signStatus == 3) {
          !this.stopLastIndex && (this.stopLastIndex = i);
        }
        if (this.detail.contractSignList[i].signStatus == 4) {
          !this.returnLastIndex && (this.returnLastIndex = i);
        }
        if (this.detail.contractSignList[i].signStatusTime) {
          !this.activeIndex && (this.activeIndex = i);
        }
        // console.log(this.meLastIndex);
      }
      // console.log(this.activeIndex);
    },
    getUserId() {
      let signIdArr = [];
      if (this.detail.taskList && this.detail.taskList.length) {
        for (let i = 0; i < this.detail.taskList.length; i++) {
          if (this.detail.taskList[i].actionCode == "SIGN") {
            signIdArr.push(this.detail.taskList[i].userId);
          }
        }
      }
      // console.log(signIdArr);
      return signIdArr;
    }
    // reNameContract(item) {
    //   this.$emit("reNameContract", item);
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.slideDetailContainter {
  width: 100%;
  display: flex;
  .swiperCustomer {
    max-width: calc(100% - 100px);
    margin: 0;
    margin-left: 5px;
    margin-right: 5px;
    .slidFlag {
      width: 100px;
      height: 300px;
      box-sizing: border-box;
      padding-top: 120px;
      .flag {
        display: inline-block;
        width: 100px;
        height: 4px;
        background: #e98880;
      }
    }
    .swiperSlidecustomer {
      width: 240px;
    }
  }
  .slideButton {
    width: 40px;
    height: 300px;
    padding-top: 90px;
    box-sizing: border-box;
    .single {
      width: 40px;
      height: 80px;
      opacity: 0.1;
      background: #000000;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      .flag {
        width: 16px;
        height: 32px;
      }
    }
    .rightSingle {
      &:hover {
        opacity: 0.3;
        .flag {
          background: url(./../../../../../assets/images/personalSignDetail/right_hopv_pre.png);
          background-size: 16px 32px;
        }
      }
      .flag {
        background: url(./../../../../../assets/images/personalSignDetail/right_nor.png);
        background-size: 16px 32px;
      }
    }
    .leftSingle {
      &:hover {
        opacity: 0.3;
        .flag {
          background: url(./../../../../../assets/images/personalSignDetail/left_hov_pre.png);
          background-size: 16px 32px;
        }
      }
      .flag {
        background: url(./../../../../../assets/images/personalSignDetail/left_nor.png);
        background-size: 16px 32px;
      }
    }
  }
}
</style>
